<template>
  <b-modal id="modal-edicao-imagem" dialog-class="modal-conta" size="lg" hide-footer :no-enforce-focus="true">
    <template slot="modal-header">
      <h5 class="modal-title">Editar imagem</h5>
      <button type="button" class="close" aria-label="Close" @click="$bvModal.hide('modal-edicao-imagem')">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    <form>
      <h6><i class="fas fa-key"></i> Dados da imagem atual</h6>
      <div class="row">
        <div class="col-md-12 mb-3">
          <img :src="obterUrlS3(imagemEditar)" width="50%" v-if="mostrarImagem" @error="imagemErro">
          <i class="fas fa-9x fa-exclamation-circle" v-else v-b-tooltip.hover title="Imagem não encontrada"></i>
        </div>
      </div>
      <p></p>
      Link: <a target="_blank" :href="obterUrlS3(imagemEditar)">{{imagemEditar.url}}</a>
      <h6><i class="fas fa-key"></i> Upload da nova imagem</h6>
      <div class="row">
        <div class="col-12 col-md-12">
          <div class="form-group">
            <label for="imagensEnunciado">Adicionar nova imagem</label>
            <form-group :text="{ required: 'Obrigatório realizar o upload da imagem' }" class="input-group mb-3" :field="$v.imagem.imagemSelecionada">
              <b-form-file
                v-model="imagem.imagemSelecionada"
                placeholder="Escolha uma imagem"
                drop-placeholder="Solte um arquivo aqui..."
                browse-text="Selecionar"
                accept="image/jpeg, image/png"
              ></b-form-file>
            </form-group>
          </div>
          <div class="form-group"  v-if="imagem.imagemSelecionada">
            <label  class="mt-3" for="lsita">Imagem selecionada:</label>
            <div class="mt-2">
              {{ imagem.imagemSelecionada.name }} <a href="javascript:void(0)" v-b-tooltip.hover title="Excluir" @click="excluirImagem(imagem.imagemSelecionada)"><i class="fas fa-trash-alt"></i></a>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center">
        <div class="d-flex align-items-center justify-content-center mt-4 mb-4">
          <button class="btn btn-primary mr-3" type="button" @click="editarImagem">Salvar</button>
          <a href="javascript:void(0)" class="btn btn-secondary" @click="$bvModal.hide('modal-edicao-imagem')">Cancelar</a>
        </div>
      </div>
    </form>
  </b-modal>
</template>

<script>
import ImagemAPI from '@/api/imagem-api'
import Swal from 'sweetalert2'
import { required } from 'vuelidate/lib/validators'
import FormGroup from '@/core/components/FormGroup'
import ResponseUtils from '@/core/util/response-utils'
import UrlUtils from '@/core/util/url-utils'

export default {
  name: 'ModalEdicaoImagem',
  components: {
    FormGroup
  },
  inheritAttrs: false,
  props: {
    imagemEditar: Object
  },
  data () {
    return {
      imagem: {
        id: null,
        url: null,
        tipo_imagem_id: null,
        tipo_imagem: null,
        imagemSelecionada: null,
        pasta: null
      },
      mostrarImagem: true
    }
  },

  mounted () {
    this.$root.$on('bv::modal::show', () => {
      this.$v.$reset()

      this.mostrarImagem = true

      this.imagem = {
        id: this.imagemEditar.id,
        url: this.imagemEditar.url,
        tipo_imagem_id: this.imagemEditar.tipo_imagem_id,
        tipo_imagem: this.imagemEditar,
        imagemSelecionada: null,
        pasta: null
      }
    })
  },

  validations: {
    imagem: {
      imagemSelecionada: { required }
    }
  },

  methods: {
    show: function () {
      this.$bvModal.show('modal-edicao-imagem')
    },

    obterUrlS3: function (imagem) {
      if (imagem.tipo_imagem_id === 1) {
        if (imagem.url.includes('cursos-plataforma/')) {
          this.imagem.pasta = 'cursos-plataforma'
          return UrlUtils.obterUrlS3(imagem.url)
        } else {
          this.imagem.pasta = 'cursos-plataforma'
          return UrlUtils.obterUrlS3('cursos-plataforma/' + imagem.url)
        }
      } else if (imagem.tipo_imagem_id === 4) {
        if (imagem.url.includes('topicos-imagem/')) {
          this.imagem.pasta = 'topicos-imagem'
          return UrlUtils.obterUrlS3(imagem.url)
        } else {
          this.imagem.pasta = 'topicos-imagem'
          return UrlUtils.obterUrlS3('topicos-imagem/' + imagem.url)
        }
      }
    },

    imagemErro () {
      this.mostrarImagem = false
    },

    excluirImagem: function (imagem) {
      this.imagem.imagemSelecionada = null
    },

    editarImagem: function () {
      this.$v.imagem.$touch()
      if (!this.$v.imagem.$invalid) {
        const loader = this.$loading.show()

        this.imagem.url = this.imagem.imagemSelecionada.name

        ImagemAPI.editar(this.imagem).then(data => {
          loader.hide()

          Swal.fire({
            icon: 'success',
            showCloseButton: true,
            text: 'Imagem atualizada com sucesso!'
          }).then(() => {
            this.$bvModal.hide('modal-edicao-imagem')
            this.$emit('imagemEditada')
          })
        }).catch(error => ResponseUtils.handleError(error, loader))
      }
    }
  }
}
</script>
<style>
  div.modal-conta i.glyphicon-calendar{
    font-size: inherit;
  }
</style>
